import type { Map as MapboxMap } from 'mapbox-gl';

export function addNetworkLayers(map: MapboxMap) {
  // WATER MAINS - Style secondary/tertiary roads as water pipes (vivid teal glow)
  map.addLayer({
    id: 'water-mains-glow',
    type: 'line',
    source: 'composite',
    'source-layer': 'road',
    filter: ['in', 'class', 'secondary', 'tertiary'],
    layout: { visibility: 'none' },
    paint: {
      'line-color': '#00ffcc',
      'line-width': ['interpolate', ['linear'], ['zoom'], 12, 4, 16, 12],
      'line-blur': 6,
      'line-opacity': 0.6,
    },
  });

  map.addLayer({
    id: 'water-mains',
    type: 'line',
    source: 'composite',
    'source-layer': 'road',
    filter: ['in', 'class', 'secondary', 'tertiary'],
    layout: { visibility: 'none' },
    paint: {
      'line-color': '#00ffcc',
      'line-width': ['interpolate', ['linear'], ['zoom'], 12, 2, 16, 5],
      'line-opacity': 0.9,
      'line-dasharray': [2, 1],
    },
  });

  // GAS MAINS - Style primary roads as gas network (vivid amber glow)
  map.addLayer({
    id: 'gas-mains-glow',
    type: 'line',
    source: 'composite',
    'source-layer': 'road',
    filter: ['in', 'class', 'primary', 'trunk'],
    layout: { visibility: 'none' },
    paint: {
      'line-color': '#ffaa00',
      'line-width': ['interpolate', ['linear'], ['zoom'], 12, 4, 16, 12],
      'line-blur': 6,
      'line-opacity': 0.6,
    },
  });

  map.addLayer({
    id: 'gas-mains',
    type: 'line',
    source: 'composite',
    'source-layer': 'road',
    filter: ['in', 'class', 'primary', 'trunk'],
    layout: { visibility: 'none' },
    paint: {
      'line-color': '#ffaa00',
      'line-width': ['interpolate', ['linear'], ['zoom'], 12, 2, 16, 5],
      'line-opacity': 0.9,
      'line-dasharray': [3, 1],
    },
  });

  // SEWER LINES - Style street-level roads as sewer network (vivid purple glow)
  map.addLayer({
    id: 'sewer-lines-glow',
    type: 'line',
    source: 'composite',
    'source-layer': 'road',
    filter: ['in', 'class', 'street', 'service'],
    layout: { visibility: 'none' },
    paint: {
      'line-color': '#cc44ff',
      'line-width': ['interpolate', ['linear'], ['zoom'], 13, 3, 16, 10],
      'line-blur': 5,
      'line-opacity': 0.6,
    },
  });

  map.addLayer({
    id: 'sewer-lines',
    type: 'line',
    source: 'composite',
    'source-layer': 'road',
    filter: ['in', 'class', 'street', 'service'],
    layout: { visibility: 'none' },
    paint: {
      'line-color': '#cc44ff',
      'line-width': ['interpolate', ['linear'], ['zoom'], 13, 1.5, 16, 4],
      'line-opacity': 0.85,
      'line-dasharray': [1, 2],
    },
  });

  // ELECTRIC CABLES - Style motorway/trunk as HV power routes (vivid orange glow)
  map.addLayer({
    id: 'electric-cables-glow',
    type: 'line',
    source: 'composite',
    'source-layer': 'road',
    filter: ['in', 'class', 'motorway', 'motorway_link'],
    layout: { visibility: 'none' },
    paint: {
      'line-color': '#ff6600',
      'line-width': ['interpolate', ['linear'], ['zoom'], 10, 4, 16, 14],
      'line-blur': 7,
      'line-opacity': 0.6,
    },
  });

  map.addLayer({
    id: 'electric-cables',
    type: 'line',
    source: 'composite',
    'source-layer': 'road',
    filter: ['in', 'class', 'motorway', 'motorway_link'],
    layout: { visibility: 'none' },
    paint: {
      'line-color': '#ff6600',
      'line-width': ['interpolate', ['linear'], ['zoom'], 10, 2, 16, 6],
      'line-opacity': 0.9,
      'line-dasharray': [4, 2],
    },
  });
}
